import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SearchResult, SearchService} from "../data-access/search.service";
import {MatCardModule} from "@angular/material/card";
import {Router} from "@angular/router";
import {KnowledgeBaseService} from "../data-access/knowledge-base.service";
import {SolutionService} from "../data-access/solution.service";
import {HeaderService} from "../../../services/header.service";
import {RemoveHtmlAndTruncatePipe} from "../../../core/pipes/remove-html-and-truncate.pipe";
import {NavigationService} from "../../../shared/data-access/navigation.service";

@Component({
  selector: 'app-kd-search-results',
  standalone: true,
  imports: [CommonModule, MatCardModule, RemoveHtmlAndTruncatePipe],
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class KdSearchResultsComponent implements OnInit, OnDestroy {
  router = inject(Router);
  headerService = inject(HeaderService);
  searchService = inject(SearchService);
  knowledgeBaseService = inject(KnowledgeBaseService)
  solutionService = inject(SolutionService);
  navigationService = inject(NavigationService);

  ngOnInit() {
    this.headerService.setHeaderSubTitle('Suchergebnisse')
  }

  gotoSolution(searchResult: SearchResult) {
    // set selected solution
    this.solutionService.selectedSolutionId$.next(searchResult.solution.id);
    this.solutionService.isSearchResult.set(true);
    this.solutionService.searchPath.set(`${searchResult.production_line.name} - ${searchResult.workplace.name} - ${searchResult.category.name}`)

    // set expanded items
    // change active page
    this.knowledgeBaseService.activePage.set(2);
    if (this.navigationService.currentUrl().includes('dashboard')) {
      this.router.navigateByUrl('/kd')
    }
  }

  ngOnDestroy() {
    console.log('destroyed')
  }

}
